module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.5bbe7891.woff";